<template>
    <div container--fluid>
        <v-layout>
            <v-container container--fluid>
                <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
                    <v-flex xs12 class="text-left">
                        <h1 class="grey--text lighten-3 mb-2">Stats</h1>
                        <v-overlay :value="loading">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </v-overlay>
                        <v-row>
                            <v-col cols="12" sm="6" md="3">
                                <v-autocomplete
                                :loading="loading"
                                item-text="season_name"
                                item-value="season_id"
                                v-model.trim="sel_seasons"
                                :items="seasons"
                                label="Seasons"
                                hint="Select a season"
                                persistent-hint
                                outlined
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-autocomplete
                                ref="div_sel"
                                clearable
                                :loading="loading"
                                item-text="division_name"
                                item-value="division_id"
                                v-model.trim="sel_divisions"
                                :items="divisions"
                                label="Divisions"
                                hint="Select a division or type in division name"
                                persistent-hint
                                outlined
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-autocomplete
                                clearable
                                :loading="loading"
                                item-text="team_name"
                                item-value="team_id"
                                v-model.trim="sel_teams"
                                :items="teams"
                                label="Teams"
                                hint="Pick your favorite team"
                                persistent-hint
                                outlined
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="2">
                                <v-select
                                :items="games"
                                item-text="gs_date_formatted"
                                item-value="gs_game_id"
                                label="Game Date"
                                hint="Pick Game Date"
                                persistent-hint
                                outlined
                                v-model.trim="sel_games"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row v-if="showTable">
                            <v-col>
                                <v-card class="elevation-12 mb-2">
                                    <v-card-title>
                                        <v-text-field v-model="search" append-icon="search" label="Search" clearable single-line hide-details></v-text-field>
                                    </v-card-title>
                                    <v-data-table dense :search="search" :loading="loading" :sort-by="['member']" :sort-desc="[false]" must-sort :items-per-page="10" :headers="headers" :items="stats" class="elevation-1">
                                        <template slot="no-data">
                                            <div class="justify-center align-center layout">
                                                <v-icon left medium>warning</v-icon>Sorry, No Stats Yet
                                            </div>
                                        </template>
                                        <template slot="no-results">
                                            <div class="justify-center align-center layout">
                                                <v-icon left medium>warning</v-icon>Sorry, No Results found for "{{ search }}"
                                            </div>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-layout>
    </div>
</template>

<script>
import store from "@modules/stats/_store";

export default {
    name: "stats",
    data() {
        return {
            sel_seasons: null,
            sel_divisions: null,
            sel_teams: null,
            sel_games: null,
            use_params: false,
            showTable: false,
            search: '',
            headers: [
            { text: '#', value: 'tshirt_number' },
            { text: 'Name', value: 'member' },
            { text: 'PTS', value: 'points' },
            { text: 'FTM', value: 'one_points' },
            { text: 'FGM', value: 'two_points' },
            { text: '3PM', value: 'three_points' },
            { text: 'PF', value: 'fouls' },
            { text: 'TF', value: 'techfouls' },
            { text: 'UF', value: 'unspfouls' },
            { text: 'DF', value: 'disqfouls' },
            ],
        };
    },
    watch: {
        sel_seasons: function(val, oldVal) {
            this.$store
            .dispatch("stats/getDivisions", { seasonId: val })
            .then(resp => {
                this.sel_teams = null;
                this.sel_games = null;
                this.$refs.div_sel.lazySearch = "";

                if(!val) {
                    this.use_params = false;
                    this.sel_divisions = null;
                }

                if(this.use_params && this.sel_seasons && this.$route.params.division_id != null){
                    this.sel_divisions = parseInt(this.$route.params.division_id);
                }
            })
            .catch(err => {
                // console.log(err);
            });
        },
        sel_divisions: function(val, oldVal) {
            if(val){
                this.$store.dispatch("stats/getTeams", { divisionId: val }).then(resp => {
                    this.sel_teams = null;
                    this.sel_games = null;

                    if(!val) {
                        this.use_params = false;
                    }

                    if(this.use_params && this.sel_divisions && this.$route.params.team_id != null){
                        this.sel_teams = this.$route.params.team_id;
                    }
                })
                .catch(err => {
                    // console.log(err);
                });
            } else {
                this.sel_teams = null;
                this.sel_games = null;
                this.showTable = false;
                this.$store.dispatch("stats/clearStatsTeams");
                this.$store.dispatch("stats/clearStatsGames");
            }
        },
        sel_teams: function(val, oldVal) {
            if(val){
                this.$store
                .dispatch("stats/getStatsGame", { divisionId:this.sel_divisions, teamId: val })
                .then(resp => {
                    this.sel_games = null;

                    if(!val) {
                        this.use_params = false;
                    }
                })
                .catch(err => {
                    // console.log(err);
                });
            } else {
                this.sel_games = null;
                this.showTable = false;
                this.$store.dispatch("stats/clearStatsGames");
            }
        },
        sel_games: function(val, oldVal) {
            if(val){
                this.$store
                .dispatch("stats/getStats", { divisionId:this.sel_divisions, teamId: this.sel_teams, gameId: val })
                .then(resp => {
                    this.showTable = true;

                    if(!val) {
                        this.use_params = false;
                    }
                })
                .catch(err => {
                    // console.log(err);
                });
            }else{
                this.showTable = false;
                this.sel_games = null;
            }
        },
    },
    computed: {
        loading() {
            return this.$store.getters["stats/statsStatus"] == "loading";
        },
        seasons() {
            return this.$store.getters["stats/seasons"];
        },
        divisions() {
            return this.$store.getters["stats/divisions"];
        },
        teams() {
            return this.$store.getters["stats/teams"];
        },
        stats() {
            return this.$store.getters["stats/stats"];
        },
        games() {
            return this.$store.getters["stats/games"];
        },
    },
    methods: {
        //code goes here
    },
    beforeCreate() {
        this.$store.dispatch("stats/getSeasons");
    },
    mounted() {
        if(this.$route.params.season_id != null){
            this.sel_seasons = parseInt(this.$route.params.season_id);
            this.use_params = true;
        }
    },
};
</script>

<style lang="scss">

</style>
